import React from 'react';
import { Slider, Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const FilterSlider = ({ value, onChange, min, max, step, marks, ...props }) => {
  const theme = useTheme();

  return (
    <Box sx={{ px: 1.5, py: 2 }}>
      <Slider
        value={value}
        onChange={onChange}
        min={min}
        max={max}
        step={step}
        marks={marks}
        sx={{
          color: theme.palette.primary.main,
          height: 6,
          '& .MuiSlider-thumb': {
            width: 18,
            height: 18,
            backgroundColor: theme.palette.primary.main,
            '&:hover, &.Mui-focusVisible': {
              boxShadow: `0 0 0 8px ${theme.palette.primary.light}40`,
            },
            '&.Mui-active': {
              width: 20,
              height: 20,
            },
          },
          '& .MuiSlider-rail': {
            opacity: 0.5,
            backgroundColor: theme.palette.secondary.main,
          },
          '& .MuiSlider-markLabel': {
            fontSize: '0.75rem',
            color: theme.palette.text.secondary,
          },
        }}
        {...props}
      />
    </Box>
  );
};

export default FilterSlider;